import { API_BASE_URL } from "src/config/apiBase";
import React, { useState } from "react";
import ImageUploader from "./ImageUploader"
import { toast } from "react-toastify";
import { getDecryptedUserFromCookie } from "./utils/getCookie";
import { decryptToken } from "./utils/getToken";

const UserRegisterModal = ({ isOpen, setIsOpen, fetchData, categories }) => {
    const [text, setText] = useState("");
    const [data, setData] = useState({
        full_name: "",
        email: "",
        password: "",
        category: '',
        website_link: "",
    })
    const [loading, setLoading] = useState(false);
    const urlmain = API_BASE_URL
    const token = decryptToken("accessToken") || ""
    const userData = getDecryptedUserFromCookie("gta_mainstateuser");
    const maxChars = 150;

    const handleChange = (e) => {
        if (e.target.value.length <= maxChars) {
            setText(e.target.value);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await fetch(`${urlmain}/register/admin1997`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify(data)
            })
            const res = await response.json();
            if(response.status===201){
                 toast.error(`${res.message}`);
                 setLoading(false)
            }
            if (response.status===200) {
                toast.success("Admin Registered Successfully")
                setLoading(false)
                setIsOpen(false)
                fetchData();
            }
        } catch (error) {
            console.error(error)
            toast.error(error)
            setLoading(false)
        }

    }




    if (!isOpen) return null;

    return (
        <>
            <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
                <div
                    className="custom-modal-content"
                    onClick={(e) => e.stopPropagation()}
                >
                    <h2 className="oms-modal-title">Register Admin</h2>
                    <form className="oms-modal-form" onSubmit={handleSubmit}>
                        {/* Title Input */}
                        <div className="oms-form-group">
                            <label htmlFor="title" className="oms-form-label">
                                Full Name
                            </label>
                            <input type="text" name="full_name" id="full_name"
                                onChange={handleInputChange}
                                placeholder="Enter Full Name" required/>
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="category">Category</label>
                            <select
                                id="category"
                                name="category"
                                value={data.category}
                                onChange={handleInputChange}
                            >
                                <option value="">Select Category</option>
                                {categories.map((cat) => (
                                    <option key={cat.id} value={cat.category_name}>
                                        {cat.category_name}
                                    </option>
                                ))}
                            </select>

                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="title" className="oms-form-label">
                                Email
                            </label>
                            <input type="email" name="email" id="email"
                                onChange={handleInputChange}
                                placeholder="Enter Email" required/>
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="website_link" className="oms-form-label">
                                Website URL
                            </label>
                            <input
                                type="url"
                                name="website_link"
                                id="website_link"
                                value={data.website_link}
                                onChange={handleInputChange}
                                placeholder="https://clientstore.com"
                            />
                            <small style={{ color: "#666" }}>
                                This URL is auto-added to API access when the admin is created.
                            </small>
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="title" className="oms-form-label">
                                Password
                            </label>
                            <input type="text" name="password" id="password"
                                onChange={handleInputChange}
                                placeholder="Enter Password" required/>
                        </div>





                        {/* Featured Image Upload */}

                        <div className="oms-form-actions">
                            <button type="button" onClick={() => setIsOpen(false)}>
                                Cancel
                            </button>
                            {
                                loading ? <button type="button" disabled={loading}>Loading...</button> : <button type="submit">Submit</button>
                            }
                        </div>
                    </form>
                </div>
            </div>


        </>
    )
}

export default UserRegisterModal;